import { ProductsSpecialPricing } from "models/storeModels/ProductsSpecialPricing";

export interface DispensePricingUpdateFunction {
    clearAllExistingPricing: boolean;
    updates: ProductsSpecialPricing[];
    packQtyType: DispensePricingUpdateQtyType;
    stores: number[];
}

export enum DispensePricingUpdateQtyType {
    Tablet,
    Pack
}